import incidents_nb from "../nb/incidents";

const incidents: typeof incidents_nb = {
  banner: {
    message_zero:
      "We are currently experiencing instability in the application. We are working to resolve the issue.",
    message_one:
      "We are currently experiencing instability with $t(services.{{service}}). Please try again later.",
    message_other:
      "We are currently experiencing instability with {{services, services_formatter}}. Please try again later.",
  },
  services: {
    FREG: "the national population register",
    BRREG: "the brønnøysund register centre",
    KARTVERKET: "the norwegian mapping autority",
    ALTINN: "altinn",
    VEGVESEN: "the norwegian public roads administration",
  },
  og: "and",
};
export default incidents;
